<div
  class="top-banner"
  [class.visible]="isVisible()"
  [style.--line-color]="color()"
>
  <span class="message">
    <img [src]="iconSrc()" alt="Banner icon" class="icon" />
    {{ message() }}
  </span>
  <div class="bottom-line"></div>
</div>
